import Container from './Container'

export default Container



// WEBPACK FOOTER //
// ./src/components/Grid/Container/index.js